export interface SearchResponseHeader {
  succeeded: boolean;
  query_time: number;
}
